// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"565":"app-word","594":"about","881":"liexiaobao-word","952":"app-page","973":"agreement"}[chunkId] + "." + {"565":"eb97e786","594":"f02d6839","881":"3b4ef5f7","952":"968a34d5","973":"a34c1207"}[chunkId] + ".css";
};